import { CachePolicy } from '@hq/api-sdk';
import { QueryClient } from '@tanstack/react-query';

/**
 * 全局 QueryClient（App 与 session 共用同一实例）。
 * 401 时由 session.onUnauthorized 调用 clear()：供应商是独立登录态，
 * 换账号后上一家的列表/详情不能残留在 5 分钟 gcTime 内。
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      // 数据变化频率分级见 @hq/api-sdk CachePolicy，页面可按数据类型覆写
      staleTime: CachePolicy.defaultStale,
      gcTime: 5 * 60_000
    }
  }
});
